import { VIEW_TYPE } from 'Pods/ThreeDStudio/Store/constants'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const DEFAULT_CONSTRAINTS = {
  viewTypes: Object.values(VIEW_TYPE),
  minItems: 1,
  maxItems: Object.values(VIEW_TYPE).length,
  requiredViews: EMPTY_ARRAY,
}

/**
 * Reads the multi-view limits a model schema declares on its input_image property:
 * which labelled views the provider accepts, in the order it expects them, how many
 * images a multi-view run may carry, and which views must be filled. Falls back to
 * every view when the schema has not resolved yet so the uploader never renders an
 * empty grid.
 *
 * @param {Object|undefined} inputImageSchema - input_schema.properties.input_image
 * @returns {{ viewTypes: string[], minItems: number, maxItems: number, requiredViews: string[] }}
 */
export function getMultiViewConstraints(inputImageSchema) {
  const {
    viewTypes, minItems, maxItems, requiredViews,
  } = inputImageSchema?.multiView || {}

  return {
    viewTypes: viewTypes?.length ? viewTypes : DEFAULT_CONSTRAINTS.viewTypes,
    minItems: minItems ?? DEFAULT_CONSTRAINTS.minItems,
    maxItems: maxItems ?? DEFAULT_CONSTRAINTS.maxItems,
    requiredViews: requiredViews ?? DEFAULT_CONSTRAINTS.requiredViews,
  }
}
